import IconError from '@apollo/icons/default/IconError.svg';
import IconSuccess from '@apollo/icons/default/IconSuccess.svg';
import React from 'react';

import { SingleGraphqlCodeBlock } from 'src/components/graphqlCodeBlock/GraphqlCodeBlock';

export const ExampleCode = ({
  goodExampleCode,
  badExampleCode,
}: {
  goodExampleCode: string | null;
  badExampleCode: string | null;
}) => {
  return (
    <div className="flex-col px-3 py-4">
      {goodExampleCode && (
        <div className="mb-3">
          <div className="flex items-center pb-2">
            <IconSuccess className="mr-1 text-icon-success" />
            <p>Correct code for this rule:</p>
          </div>
          <div className="rounded border border-midnight-light bg-midnight-darker px-2 py-1">
            <SingleGraphqlCodeBlock
              darkMode
              sdl={goodExampleCode}
              preWrapWhiteSpace={false}
              className="px-2 py-3.5"
            />
          </div>
        </div>
      )}
      {badExampleCode && (
        <div>
          <div className="flex items-center pb-2">
            <IconError className="mr-1 text-icon-error" />
            <p>Incorrect code for this rule:</p>
          </div>
          <div className="rounded border border-midnight-light bg-midnight-darker px-2 py-1">
            <SingleGraphqlCodeBlock
              darkMode
              sdl={badExampleCode}
              preWrapWhiteSpace={false}
              className="px-2 py-3.5"
            />
          </div>
        </div>
      )}
    </div>
  );
};
